import React, { useState } from 'react';
import * as S from './Aside.styles';
import classnames from 'classnames';



const Aside = ({ onMenuSelect,data,selectedMenu }) => {


  const handleSubMenuSelect = ((e,subMenuId) => {
    e.stopPropagation()
  
    onMenuSelect({order:selectedMenu?.order,data:subMenuId})
  });
  const handleMenuSelect = ((e,menuId) => {
    e.preventDefault()
    onMenuSelect({order:menuId,data:selectedMenu?.data})
  });


  return (
    <S.Aside>
      {data?.map((item,index)=>{
return (    <div key={`aside${index}`} open={selectedMenu?.order === item?.id} onClick={(e) => handleMenuSelect(e,item?.id)} >
<p className={`headTitle`}><span className={classnames(item?.icon?.iconClasses)}></span> {item?.primaryText}</p>
{
  selectedMenu?.order === item?.id && <ul>
    {item?.childNodes?.map((child,chidlIndex)=>{
return(  <li key={`asideChild${chidlIndex}`} className={`${selectedMenu?.data == child?.id ? 'active' : ''}`} onClick={(e) => handleSubMenuSelect(e,child?.id)}>{child?.primaryText}</li>
)

    })}
  </ul>
}

</div>)
      })}
  
    </S.Aside>
  );
};

export default Aside;
